import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouteGuardService } from "./route-guard.service";

import { ErrorComponent } from "./components/error/error.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { LoginComponent } from "./components/login/login.component";
import {RequestComponent} from "./components/request/request.component";
import {RequestDetailComponent} from "./components/request-detail/request-detail.component";
import {RequestUpdateComponent} from "./components/request-update/request-update.component";
import {RequestCompileComponent} from "./components/request-compile/request-compile.component";
import {CustomerComponent} from "./components/customer/customer.component";
import {CustomerDetailComponent} from "./components/customer-detail/customer-detail.component";
import {CustomerUpdateComponent} from "./components/customer-update/customer-update.component";
import {SupplierComponent} from "./components/supplier/supplier.component";
import {SupplierUpdateComponent} from "./components/supplier-update/supplier-update.component";
import {SupplierDetailComponent} from "./components/supplier-detail/supplier-detail.component";
import {ReferrerComponent} from "./components/referrer/referrer.component";
import {ReferrerUpdateComponent} from "./components/referrer-update/referrer-update.component";
import {ReferrerDetailComponent} from "./components/referrer-detail/referrer-detail.component";

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    pathMatch: 'full',
    component: LoginComponent
  },
  {
    path: 'richiesta',
    pathMatch: 'full',
    component: RequestComponent
  },
  {
    path: 'richiesta/modifica/:id',
    pathMatch: 'full',
    component: RequestUpdateComponent
  },
  {
    path: 'richiesta/compilazione/:id',
    pathMatch: 'full',
    component: RequestCompileComponent
  },
  {
    path: 'richiesta/:id',
    pathMatch: 'full',
    component: RequestDetailComponent
  },
  {
    path: 'clienti',
    pathMatch: 'full',
    component: CustomerComponent
  },
  {
    path: 'clienti/modifica/:id',
    pathMatch: 'full',
    component: CustomerUpdateComponent
  },
  {
    path: 'clienti/:id',
    pathMatch: 'full',
    component: CustomerDetailComponent
  },
  {
    path: 'fornitori',
    pathMatch: 'full',
    component: SupplierComponent
  },
  {
    path: 'fornitori/modifica/:id',
    pathMatch: 'full',
    component: SupplierUpdateComponent
  },
  {
    path: 'fornitori/:id',
    pathMatch: 'full',
    component: SupplierDetailComponent
  },
  {
    path: 'segnalatori',
    pathMatch: 'full',
    component: ReferrerComponent
  },
  {
    path: 'segnalatori/modifica/:id',
    pathMatch: 'full',
    component: ReferrerUpdateComponent
  },
  {
    path: 'segnalatori/:id',
    pathMatch: 'full',
    component: ReferrerDetailComponent
  },
  {
    path: 'error',
    pathMatch: 'full',
    component: ErrorComponent
  },
  {
    path: 'dashboard',
    pathMatch: 'full',
    component: DashboardComponent
  },
  {
    path: '**',
    redirectTo: 'error'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [RouteGuardService]
})
export class AppRoutingModule { }
